module.exports = __webpack_public_path__ + "img/178-palau.b1b9266f.svg";